/* Tiroir panier « façon Rue des Peignoirs » — thèmes FullStack (02-11-2026).
   Carte complémentaire : changement de variante (prix affiché) et bouton « + ».
   Écoute posée UNE fois sur document : cart-drawer.js remplace tout l'intérieur du
   tiroir à chaque changement, un écouteur posé sur la carte serait perdu. */
(function () {
  if (window.__rdpPanier) return;
  window.__rdpPanier = true;

  function carteDe(el) { return el.closest('[data-rdpp-carte]'); }

  /* Prix affiché = celui de la variante choisie ; prix barré + pastille seulement
     quand la remise s'applique VRAIMENT à cette variante (calculé en Liquid). */
  function afficherPrix(carte, opt) {
    var zone = carte.querySelector('[data-rdpp-prix]');
    if (!zone || !opt || !opt.dataset.prix) return;
    zone.textContent = '';
    var b = document.createElement('b');
    b.textContent = opt.dataset.remise || opt.dataset.prix;
    zone.appendChild(b);
    if (opt.dataset.remise) {
      var s = document.createElement('s');
      s.textContent = opt.dataset.prix;
      var p = document.createElement('span');
      p.className = 'rdpp-duo__badge';
      p.textContent = carte.dataset.badge || '';
      zone.appendChild(document.createTextNode(' '));
      zone.appendChild(s);
      zone.appendChild(document.createTextNode(' '));
      zone.appendChild(p);
    }
  }

  function erreur(carte, oui) {
    var champ = carte.querySelector('[data-rdpp-select]');
    var msg = carte.querySelector('[data-rdpp-msg]');
    if (champ && champ.tagName === 'SELECT') champ.classList.toggle('is-erreur', oui);
    if (msg) msg.hidden = !oui;
  }

  document.addEventListener('change', function (e) {
    var sel = e.target && e.target.closest && e.target.closest('select[data-rdpp-select]');
    if (!sel) return;
    var carte = carteDe(sel);
    afficherPrix(carte, sel.selectedOptions[0]);
    /* La photo suit la variante choisie, quand la variante a sa propre photo. */
    var img = carte.querySelector('[data-rdpp-img]'), o = sel.selectedOptions[0];
    if (img && o && o.dataset.img) img.src = o.dataset.img;
    if (sel.value) erreur(carte, false);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-rdpp-ajout]');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-chargement')) return;
    var carte = carteDe(btn);
    var champ = carte.querySelector('[data-rdpp-select]');
    var id = champ ? parseInt(champ.value, 10) : NaN;
    /* Article à tailles : aucune taille n'est choisie d'office, le « + » n'ajoute rien tant qu'on n'a pas choisi. */
    if (!id) { erreur(carte, true); if (champ && champ.focus) champ.focus(); return; }

    var tiroir = document.querySelector('cart-drawer');
    /* `Theme` est déclaré en `const` par snippets/scripts.liquid : il n'est PAS une propriété de window. */
    var routes = (typeof Theme !== 'undefined' && Theme.routes) || {};
    btn.classList.add('is-chargement');
    btn.setAttribute('aria-busy', 'true');

    fetch(routes.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: id, quantity: 1 }],
        sections: tiroir && tiroir.dataset.sectionId ? tiroir.dataset.sectionId : '',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (rep) {
        if (rep.status && rep.status >= 400) throw new Error(rep.description || rep.message || 'Ajout impossible');
        return fetch((routes.cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) { return { rep: rep, cart: cart }; });
      })
      .then(function (x) {
        var ev = new Event('cart:updated', { bubbles: true });
        ev.detail = { resource: {}, data: { itemCount: x.cart.item_count, source: 'rdp-panier', sections: x.rep.sections } };
        document.dispatchEvent(ev);
      })
      .catch(function (err) {
        window.__rdpPanierErreur = String((err && err.message) || err);
        btn.classList.remove('is-chargement');
        btn.removeAttribute('aria-busy');
        document.dispatchEvent(new CustomEvent('toast:open', { detail: { type: 'error', message: String((err && err.message) || err) } }));
      });
  });
})();
